export default __webpack_public_path__ + "static/media/style18.c976da47.svg";